import React, { useEffect, useId, useRef } from "react";
import { useTranslation } from "react-i18next";

// Accessible confirmation modal (Escape or Cancel closes it; nothing happens without explicit confirmation).
export default function ConfirmDialog({ title, note, confirmLabel, danger = false, busy = false, onConfirm, onCancel }) {
  const { t } = useTranslation();
  const titleId = useId();
  const cancelRef = useRef(null);
  useEffect(() => {
    cancelRef.current?.focus();
    const onKey = (e) => { if (e.key === "Escape" && !busy) onCancel(); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [busy, onCancel]);
  return (
    <div className="fixed inset-0 z-[120] flex items-end justify-center bg-slate-950/50 p-4 sm:items-center">
      <div role="dialog" aria-modal="true" aria-labelledby={titleId} className="w-full max-w-md rounded-3xl bg-white p-5 shadow-2xl">
        <h2 id={titleId} className="text-lg font-bold text-slate-900">{title}</h2>
        {note && <p className="mt-2 text-sm text-slate-600">{note}</p>}
        <div className="mt-5 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <button ref={cancelRef} type="button" className="lina-action min-h-[44px]" disabled={busy} onClick={onCancel}>{t("propertyRequest.mine.cancel")}</button>
          <button type="button" className={`${danger ? "lina-action-danger" : "lina-action-primary"} min-h-[44px]`} disabled={busy} onClick={onConfirm}>{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
}
